import { z } from 'zod'

export const securityOwnershipStatusSchema = z.object({
  latest: z.object({
    verified: z.boolean(),
    checked_at: z.string().datetime(),
  }).nullable(),
})
export type SecurityOwnershipStatus = z.infer<typeof securityOwnershipStatusSchema>

/** Unknown or failed reads must not be presented as a failed ownership check. */
export function ownershipStatusLabel(latest: SecurityOwnershipStatus['latest'] | undefined, loading: boolean, failed: boolean): string {
  if (failed) return 'Ownership status unavailable'
  if (loading && latest === undefined) return 'Loading ownership status…'
  if (!latest) return 'Awaiting ownership'
  return latest.verified ? 'Ownership confirmed' : 'Last ownership check failed'
}

export const SecuritySetupChallengeSchema = z.object({ nonce: z.string().min(1).nullable(), exempt: z.boolean() })
